"use client";

export type ContactOptionGuideItem = {
  label: string;
  description: string;
  order?: number;
  isVisible?: boolean;
};

interface ContactOptionsGuideSectionProps {
  title?: string;
  description?: string;
  items: ContactOptionGuideItem[];
}

export default function ContactOptionsGuideSection({
  title = "Which Contact Option Should You Choose?",
  description,
  items,
}: ContactOptionsGuideSectionProps) {
  const visible = items
    .filter((item) => item.isVisible !== false && item.label.trim())
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  if (!visible.length) return null;

  return (
    <section className="mb-20 max-w-4xl md:mx-auto mx-5" aria-label={title}>
      <div className="px-6 sm:px-14">
        {title.trim() ? (
          <h2 className="text-2xl font-bold text-[#F5F5F5]">{title}</h2>
        ) : null}
        {description?.trim() ? (
          <p className="mt-10 text-lg leading-7 text-[#F5F5F5]/90">
            {description}
          </p>
        ) : null}
        <ul className="mt-6 list-disc space-y-8 pl-6 text-md leading-7 text-[#F5F5F5]/90 marker:text-[#F5F5F5]">
          {visible.map((item, index) => (
            <li key={`${item.label}-${index}`} className="pl-1">
              <strong className="font-bold text-[#F5F5F5]">{item.label}</strong>{" "}
              {item.description}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
